/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, AlertTitle, Box, Button, Paper, Typography, useTheme } from "@mui/material";
import { Form, Formik } from "formik";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  addVehicle,
  initialFormWithVehiclesId,
} from "../../actions/formAction";
import Loader from "../../components/Loader";
import PageHeader from "../../components/PageHeader/PageHeader";
import CarStatus from "./components/CarStatus";
import NewVehicleInfo from "./components/NewVehicleInfo";
import TowingInfo from "./components/TowingInfo";
import WareHouseLoadInfo from "./components/WareHouseLoadInfo";
import FileUpload from "../../components/FileUpload";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetState as addNewResetState } from "../../slices/addNewVehiclesSlice";
import { addDeletedObject } from "../../slices/formInitialSlice";
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import React from "react";

import * as Yup from "yup";
import { useEffect, useState } from "react";
import { baseUrl } from "../../util/constant";
import CancelledOrReturnedOrPendingAgreementInfo from "./components/CancelledOrReturnedOrPendingAgreementInfo";

const AddNewVehicles = () => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formReducser = useSelector((state) => state.form);

  const userReducer = useSelector((state) => state.user);

  const [isClient, setIsClient] = useState(null);

  const vehicleInfo = useSelector((state) => state.vehicleInfo);
  const vehicleId = searchParams.get("vehicleId") || null;
  const backLink = searchParams.get("backLink") || "";
  const isEdit = searchParams.get(("vehicleId")) ? true : false;

  const add = useSelector((state) => state.add);
  const { vehicleAddedSuccessfully } = useSelector((state) => state.add);
  const url = baseUrl + "";

  const [initialValues, setInitialValues] = useState(null);

  const defultInitialValues = {
    entryDate: new Date().toISOString().substr(0, 10), // required today's date

    vin: "",
    year: "", //required
    transportCompany: null,

    price: 0,
    weight: 0,
    shippingPrice: 0,
    title: false,
    key: false,
    hasCatalyst: false,
    client: userReducer?.accountType === "client" ? userReducer?.userInfo?.client : null,
    arrivalNote: "",
    vehicleType: null,
    destination: null,
    purchasePriceFile: [],
    shippingPriceFile: [],
    vehiclePictures: [],
    warehousePictures: [],
    make: null,
    model: null,
    color: null,
    fuelType: null,
    warehouseArrivalDate: null,
    etaWarehouseArrivalDate: null,
    container: null,
    
    status: {},
    partsWithCar: false,
    removeEngine: false,
    deleted: false,
  };

  const validationSchema = Yup.object().shape({
    client: Yup.object().required("Client is required"),

    vehicleType: Yup.object().required("Vehicle type is required"),

    make: Yup.object().required("Make is required"),

    model: Yup.object().required("Model is required"),

    vin: Yup.string().required("VIN is required"),

    color: Yup.object().required("Color is required"),
  

  
    weight: Yup.number().required("Weight is required"),

      price: Yup.object().when([], {
      is: () => isClient === true,
      then: () => Yup.number()
      .typeError("Car Price must be a valid number")
      .positive("Car Price must be greater than zero")
      .required("Car Price is required"),
      otherwise: () => Yup.number().required("Car Price is required"),
    }),



    year: Yup.string()
      .matches(/^[0-9]{4}$/, "Year must be a valid 4-digit number")
      .test(
        "valid-year",
        "Year must be between 1900 and the current year",
        (value) => {
          const currentYear = new Date().getFullYear() + 1;
          const year = parseInt(value, 10);
          return year >= 1900 && year <= currentYear;
        }
      )
      .required("Year is required"),

    fuelType: Yup.object().required("Fuel type is required"),

    entryDate: Yup.string()
      .matches(
        /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
        "Entry date must be in the format YYYY-MM-DD"
      )
      .required("Entry date is required"),

    purchasePriceFile: Yup.object().when([], {
      is: () => isClient === true,
      then: () => Yup.array()
        .required("Purchase Price File is required")
        .min(1, "Purchase Price File is required"),
      otherwise: () => Yup.array().nullable(),
    }),


    transportCompany: Yup.object().when([], {
      is: () => isClient === true,
      then: () => Yup.object().required("Transport company is required"),
      otherwise: () => Yup.object().nullable(),
    }),

    destination: Yup.object().when([], {
      is: () => isClient === true,
      then: () => Yup.object().required("Destination is required"),
      otherwise: () => Yup.object().nullable(),
    }),

    etaWarehouseArrivalDate: Yup.date()
      .when("status.id", {
        is: 1,
        then: () => Yup.date()
          .required("ETA Warehouse Arrival Date is required")
          .typeError("ETA Warehouse Arrival Date must be a valid date"),
        otherwise: () => Yup.date().nullable(),
      }),



  });





  useEffect(() => {
    if (userReducer.accountType === "client") {
      setIsClient(true);
    } else {
      setIsClient(false);
    }
  }, [userReducer.accountType]);



  useEffect(() => {
    dispatch(initialFormWithVehiclesId({ vehicleId }));

    // dispatch(addNewResetState())
  }, [dispatch]);

  const handleKeyDown = (event, submitForm) => {
    if (event.key === "Enter") {
      event.preventDefault();
      submitForm();
    }
  };

  const handleSubmit = async (values) => {
    dispatch(addVehicle({ data: values, id: vehicleId }));
  };

  const hasFormErrors = (formik) => {
    return Object.keys(formik.errors).length > 0;
  };

  if (vehicleAddedSuccessfully) {
    dispatch(addNewResetState());

    navigate(`/vehicles?${backLink.replaceAll("*", "&")}`);
  }

  const handleBack = () => {
    navigate(`/vehicles?${backLink.replaceAll("*", "&")}`);
  };


  // Fetch vehicle info if vehicleId is provided and check if object was deleted add on verificationValues List
  useEffect(() => {
    if (vehicleId !== null) {
      if (vehicleInfo.loading === "succeeded") {
        setInitialValues(vehicleInfo.Object);

        const deletedFields = [
          { key: "vehicleType", name: "vehicleTypeList" },
          { key: "transportCompany", name: "transportCompanyList" },
          { key: "client", name: "clientList" },
          { key: "make", name: "makeList" },
          { key: "color", name: "colorList" },
          { key: "model", name: "modelList" },
          { key: "fuelType", name: "fuelTypeList" },
        ];

        deletedFields.forEach(({ key, name }) => {
          const obj = vehicleInfo.Object?.[key];
          if (obj?.deleted) {
            dispatch(addDeletedObject({ name, object: obj }));
          }
        });
      }
    } else {
      setInitialValues(defultInitialValues);
    }
  }, [vehicleId, vehicleInfo.loading]);






  if (
    initialValues === null ||
    formReducser.loading === "pending" ||
    formReducser.loading === "idle" ||
    (vehicleId !== null &&
      (vehicleInfo.loading === "pending" || vehicleInfo.loading === "idle"))
  ) {
    return <Loader />;
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={true}
    >
      {(formik) => (
        <Form>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>
            <Box sx={{ position: 'relative', width: 48, height: 48 }}>
              <DirectionsCarFilledOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: 40, position: 'absolute', left: 0, top: 0, zIndex: 1 }} />
              <AddCircleOutlineIcon sx={{ color: theme.palette.secondary.main, fontSize: 24, position: 'absolute', right: -8, bottom: -8, zIndex: 2, bgcolor: theme.palette.background.paper, borderRadius: '50%' }} />
            </Box>
            <Typography variant="h4" sx={{ color: '#0B3C5D', fontWeight: 800, letterSpacing: 1 }}>
              {t('Add New Vehicle')}
            </Typography>

          </Box>
          {/* Car Status */}
          <CarStatus isClient={isClient} />

          {/*New Vehicle Information*/}
          <Paper elevation={3} sx={{
            borderRadius: 4,
            boxShadow: '0 4px 24px 0 rgba(11, 60, 93, 0.10)',
            bgcolor: theme.palette.background.paper,
            p: { xs: 2, md: 4 },
            mt: 2,
            maxWidth: 1200,
            mx: 'auto',
          }}>
            <NewVehicleInfo isClient={isClient} />
            <TowingInfo isEdit={isEdit} />
            {formik?.values?.status.id !== 1 && (
              <WareHouseLoadInfo status={formik?.values?.status} />)
            }
            {(formik?.values?.status.id === 3 || formik?.values?.status.id === 4) && (
              <CancelledOrReturnedOrPendingAgreementInfo
                status={formik?.values?.status}
              />)}
            <Box
              display="grid"
              gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr' }}
              gap={{ xs: 4, md: 8 }}
              paddingTop={{ xs: 3, md: '74px' }}
              margin={{ xs: '32px 0', md: '64px 49px' }}
            >
              <Box>
                <PageHeader width={"50%"} title={t("vehiclePictures").toLocaleUpperCase()} />
                <FileUpload
                  disabled={
                    formik?.values?.status.id !== 1 && formik?.values?.status.id !== 2
                  }
                  label={t("vehiclePictures")}
                  uploadName="VehiclePictures"
                  formikName="vehiclePictures"
                />
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%",
                    pt: 2,
                    flexDirection: "row",
                    gap: 2,
                  }}
                >
                  {formik.values?.vehiclePictures?.map((item) => (
                    <Box key={item.id} sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.10)', border: `1px solid ${theme.palette.grey[200]}`, mb: 1 }}>
                      <a
                        href={`${url}${item.filePath}`}
                        download={item.fileName}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <img
                          src={`${url}${item.filePath}`}
                          alt={item.fileName}
                          width={"100px"}
                          height={"100px"}
                          style={{ objectFit: 'cover', background: theme.palette.background.default }}
                        />
                      </a>
                    </Box>
                  ))}
                </Box>
              </Box>
              
              <Box
                sx={{
                  visibility:
                    formik?.values?.status?.id === 1 ||
                      formik?.values?.status?.id === 6
                      ? "hidden"
                      : "visible",
                }}
              >
                <PageHeader width={"50%"} title={t("warehousePictures").toLocaleUpperCase()} />
                <FileUpload
                  disabled={
                    formik?.values?.status.id !== 1 && formik?.values?.status.id !== 2
                  }
                  label={t("warehousePictures")}
                  uploadName="WarehousePictures"
                  formikName="warehousePictures"
                />
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%",
                    pt: 2,
                    flexDirection: "row",
                    gap: 2,
                  }}
                >
                  {formik.values?.warehousePictures?.map((item) => (
                    <Box key={item.id} sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.10)', border: `1px solid ${theme.palette.grey[200]}`, mb: 1 }}>
                      <a
                        href={`${url}${item.filePath}`}
                        download={item.fileName}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <img
                          src={`${url}${item.filePath}`}
                          alt={item.fileName}
                          width={"100px"}
                          height={"100px"}
                          style={{ objectFit: 'cover', background: theme.palette.background.default }}
                        />
                      </a>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Paper>

          {hasFormErrors(formik) || add.hasError ? (
            <Box className="errorBox" sx={{ maxWidth: 700, mx: 'auto', mt: 3 }}>
              <Alert severity="error" sx={{ borderRadius: 2, boxShadow: '0 2px 8px 0 rgba(217, 179, 16, 0.10)' }}>
                <AlertTitle sx={{ color: theme.palette.warning.dark }}>Error</AlertTitle>
                {Object.keys(formik.errors).map((fieldName, index) => {
                  if (Array.isArray(formik?.errors[fieldName])) {
                  } else {
                    return <div key={index}>{formik.errors[fieldName]}</div>;
                  }
                })}
                {add.hasError ? <div>{add.errorMessage}</div> : ""}
              </Alert>
            </Box>
          ) : (
            ""
          )}

          <Box display="flex" flexDirection={{ xs: 'column', md: 'row-reverse' }} alignItems="center" gap={2} margin={{ xs: '32px 0', md: '64px 49px' }}>
            {!add.isLoading ? (
              <div onKeyDown={(e) => handleKeyDown(e, formik.submitForm)}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    bgcolor: theme.palette.secondary.main,
                    color: theme.palette.primary.main,
                    fontWeight: 700,
                    borderRadius: '10px',
                    width: { xs: '100%', md: '231px' },
                    height: '55px',
                    boxShadow: '0 2px 8px 0 rgba(217, 179, 16, 0.10)',
                    fontSize: 18,
                    mb: { xs: 1, md: 0 },
                    '&:hover': { bgcolor: theme.palette.secondary.dark, color: '#fff' },
                  }}
                >
                  {t("save")}
                </Button>
              </div>
            ) : (
              <Loader />
            )}
            <Button
              onClick={() => handleBack()}
              variant="outlined"
              sx={{
                border: `2px solid ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                fontWeight: 700,
                borderRadius: '10px',
                width: { xs: '100%', md: '231px' },
                height: '55px',
                fontSize: 18,
                bgcolor: theme.palette.background.paper,
                '&:hover': { bgcolor: theme.palette.primary.main, color: '#fff', borderColor: theme.palette.secondary.main },
              }}
            >
              {t("cancel")}
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};
export default AddNewVehicles;